import Vue from 'vue';
import Component from 'vue-class-component';
import template from './disclaimer-page.html';
import './disclaimer.scss';

@Component({
	template: template,
})
export class DisclaimerPage extends Vue {}
